import { Link } from 'react-router-dom';

export default function ProcessSection() {
  return (
    <section className="nvb wh">
      <div className="wrap">
        <div className="hd2 rv">
          <div>
            <small>데이터 연결부터 조직 내 활용까지</small>
            <h2>
              데이터 연결부터
              {' '}
              <em>AI Agent 완성</em>
              까지
            </h2>
          </div>
        </div>
        <div className="wheel">
          <div className="stx rv">
            <div className="bc">
              <div className="t">
                <span className="no">01 CONNECT</span>
              </div>
              <div className="t" style={{ marginTop: "12px" }}>지식파이프라인 구축</div>
              <p>여러 곳에 있는 파일·웹·DB 데이터를 한곳에 연결</p>
              <div className="kv">
                <b>파일 + 웹 + DB</b>
                AI가 참고할 지식으로
              </div>
              <Link to="/product#s2">
                지식 파이프라인
                <svg className="i" style={{ width: "15px", height: "15px" }}>
                  <use href="#arr" />
                </svg>
              </Link>
            </div>
            <div className="bc">
              <div className="t">
                <span className="no">02 BUILD</span>
              </div>
              <div className="t" style={{ marginTop: "12px" }}>워크플로우 구축</div>
              <p>지식베이스와 업무 흐름을 연결해 우리 업무에 맞는 AI Agent 제작</p>
              <div className="kv">
                <b>지식 + 워크플로우</b>
                우리 업무에 맞는 AI로
              </div>
              <Link to="/product#s3">
                워크플로우 빌더
                <svg className="i" style={{ width: "15px", height: "15px" }}>
                  <use href="#arr" />
                </svg>
              </Link>
            </div>
          </div>
          <div className="ring rv d1">
            <svg viewBox="0 0 420 420">
              <g className="orb">
                <circle cx="210" cy="210" r="150" fill="none" stroke="#D5D2FA" strokeWidth="2" strokeDasharray="6 8" />
                <circle cx="210" cy="60" r="5" fill="#B9B4F3" />
                <circle cx="340" cy="285" r="5" fill="#B9B4F3" />
                <circle cx="80" cy="285" r="5" fill="#B9B4F3" />
              </g>
              <circle cx="210" cy="210" r="190" fill="none" stroke="#E6E4FB" strokeWidth="1" />
              <path className="cn" d="" stroke="#B9B4F3" strokeWidth="2" strokeDasharray="4 5" fill="none" />
            </svg>
            <div className="ctr">
              <img src="/site/logos/ax-symbol-white.svg" alt="AcXion-On" />
            </div>
            <span className="bd">01</span>
            <span className="bd">02</span>
            <span className="bd">03</span>
          </div>
          <div className="stx rv d2">
            <div className="bc">
              <div className="t">
                <span className="no">03 USE</span>
              </div>
              <div className="t" style={{ marginTop: "12px" }}>AI Agent 배포</div>
              <p>워크플로우 배포·사용자 포털 활용</p>
              <div className="kv">
                <b>관리자 → 구성원</b>
                일상 업무 속으로
              </div>
              <Link to="/product#s4">
                AI Agent 활용
                <svg className="i" style={{ width: "15px", height: "15px" }}>
                  <use href="#arr" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
        <div className="pnote rv">
          <span>
            웹 검색·Google Drive·이메일·Slack·Notion·MCP 서버를 업무 흐름에 연결할 수 있습니다.
          </span>
        </div>
      </div>
    </section>
  );
}
